import type { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import type { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';

export class CatalogTechRadarApi implements TechRadarApi {
  constructor(private readonly data: TechRadarLoaderResponse) {}

  async load(_id?: string): Promise<TechRadarLoaderResponse> {
    return this.data;
  }
}
